import React, { useState, useEffect } from 'react';

const Successwithfeedbackmodal = ({ show, onClose, success, message }) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const userId = localStorage.getItem('userid');
    if (userId) {
      setUserId(userId);
    }
  }, []);

  const handleSubmitFeedback = async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const url = process.env.REACT_APP_API_URL + 'feedback/createFeedback';
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userid: userId,
          rating: rating,
          message: feedbackMessage,
        }),
      });
      setRating(0);
      setFeedbackMessage('');
      setShowFeedback(false);
      onClose();
    } catch (error) {
      console.error('Error submitting feedback:');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowFeedback(false);
    setRating(0);
    setFeedbackMessage('');
    onClose();
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {!showFeedback && (
            <div className="modal-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="modal-title fs-4 fw-semibold">
                  {success ? "Success!" : "Notice"}
                </h2>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={handleClose}
                  aria-label="Close"
                ></button>
              </div>
              <p className="text-secondary mb-4">{message}</p>
              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => setShowFeedback(true)}
                >
                  Give Feedback
                </button>
                <button 
                  className="btn btn-primary"
                  onClick={handleClose}
                >
                  OK
                </button>
              </div>
            </div>
          )}

          {/* Feedback Section */}
          {showFeedback && (
            <div className="modal-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="modal-title fs-4 fw-semibold">Feedback</h2>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={handleClose}
                  aria-label="Close"
                ></button>
              </div>

              <div className="text-center mb-4">
                <p className="fs-5 mb-3">How would you rate your experience?</p>
                <div className="d-flex justify-content-center gap-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      onClick={() => setRating(star)}
                      className="btn btn-link p-0"
                      style={{ color: star <= rating ? '#ffc107' : '#dee2e6' }}
                    >
                      <i className="fas fa-star fa-lg"></i>
                    </button>
                  ))}
                </div>
              </div>

              <div className="mb-4">
                <p className="fs-5 mb-2">Would you like to add something?</p>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Your feedback helps us improve..."
                  value={feedbackMessage}
                  onChange={(e) => setFeedbackMessage(e.target.value)}
                ></textarea>
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => setShowFeedback(false)}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSubmitFeedback}
                  disabled={loading || rating === 0}
                >
                  {loading ? 'Submitting...' : 'Submit Feedback'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Successwithfeedbackmodal;